module.exports = __webpack_public_path__ + "static/img/02.d8b3cb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/02.png
// module id = UJ8s
// module chunks = 1